import { RAISIN_LIGHT_BLUE_SITE_LOGO } from '../../../../constants';
export const fiMenus = (isThemeV2) => ({
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/fi-fi/',
            url: isThemeV2
                ? RAISIN_LIGHT_BLUE_SITE_LOGO
                : 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
            alt: 'Raisin',
        },
    ],
    navItems: [],
    actionItems: [],
});
//# sourceMappingURL=fiMenus.js.map